console.debug("LOADING SourceAbstract")
import { flow, observable, computed, action, makeObservable, runInAction } from "mobx"
import { TraxisModel } from "store/api/TraxisModel"
import { rootStore } from "store/RootStore"
import { moment } from "store/util/moment"
import { PlayerProgressBar } from "../PlayerProgressBar"
//import { MediaService } from "store/qlapi/MediaService"
import { StreamPlayList } from "store/api/StreamPlayList"
import { lazyObject } from "store/ModelTools"
import { TIME_FORMAT_BACKEND } from "store/model/Time"
import { serviceUrls } from "store/qlapi/ServiceUrls"
// avoid circular dependency when importing SourceAdPlaylist
import { ClassAbstract, SourceTypeList, SourceAdPlaylist, AdState, ReplayAd, LinearAd, FastFwdAd } from "./InternalImports"
import { logLevel } from "store/qlapi/LogService"
import { appFeatures } from "AppFeatures"
import { cDebug } from "utils/TestSupport"
import { isSafari, sleep } from "utils/Utils"
import { controlsTimerHandler } from "scenes/Player/Player"
import { Wait } from "store/util/Wait"
import { ErrorBase } from "store/ErrorBase"
import { Mutex } from 'async-mutex'
import { channelId, eventId, seriesId, startTs, endTs, isTimeInEventRange, posterUrl } from "utils/EventHelpers"
import { l10n } from "store/lang/L10n"

import { getCoCoModule } from "store/page/repo/CoCoModule"
const CoCo = await getCoCoModule()

export class SourceAbstract extends ClassAbstract {
	id = null
	// MTVW-859: channelId to remove traxis Channel
	channelId = null

	oCreatePlaylist = new TraxisModel()
	// MTV-3570: use new StreamPlayList instead of StreamPlayListAbstract, since we don't need
	// traxis' CreatexxxPlaylist anymore since media microservice v008
	//@observable playlist = null
	playlist = lazyObject(this, "playlist", StreamPlayList)

	GetEvent = null

	progressBar = new PlayerProgressBar(this, "progressBar")

	isLoading = true

	// GT12 properties
	sessionId = null
	pauseAd = null
	trueReplaySession = false
	restartDone = false
	replayAdInfo = null
	fastForwardAdInfo = null
	playAfterAd = () => { }
	sessionAdZones = null
	adsService = rootStore.adsService
	playEventActive = false
	adZone = null
	adZoneFetchPosiiton = null
	sessionStart = null
	sessionEnd = null
	// MTVW-1101
	contentEndPosition = null
	adPlayStart = 0
	adStartPosition = 0
	adEndPosition = 0
	adPauseStart = 0
	disablePauseAd = false
	adState = new AdState()
	interactionActive = false
	debounceEvent = false
	markerPosD = null // indicates marker position D, if !null prevent display of buttons
	timeoutId = null
	msEpg = rootStore.page.MsEpg
	contentPlayerName = null
	// MTVW-788, MTVW-787: _player for parent constructors
	_player = null
	// MTVW-444, MTVW-788, MTVW-787
	_waitPreload = new Wait(this, "preload")
	static capturedVideoImage = null
	bmPos = null
	_mutex = new Mutex()
	// for preventing notifyStopped on live tile, since interactionEvent could be invoked more than once
	isOnDiscover = false

	// invoked after playlist is loaded,
	// allows to modify the stream position before openStreamAsync() of PlayerVo is called
	playlistLoadedCallback = () => { }

	constructor(parent, path) {
		super(parent, path)
		makeObservable(this, {
			id: observable,
			channelId: observable,
			oCreatePlaylist: observable,
			playlist: observable,
			GetEvent: observable,
			progressBar: observable,
			isLoading: observable,
			Event: computed,
			rangeEventMinTs: computed,
			rangeEventMaxTs: computed,
			nextEpisodeInfo: computed,
			setAsLoaded: action,
			// GT12
			pauseAd: observable,
			removePauseAd: action,
			checkPauseAd: action,
			setPauseAd: action,
			replayAdInfo: observable,
			setReplayAdInfo: action,
			setFfwdAdInfo: action,
			fastForwardAdInfo: observable,
			sessionAdZones: observable,
			pauseEvent: action,
			playStartEvent: action,
			playCompleteEvent: action,
			adZone: observable,
			adState: observable,
			skipAd: action,
			checkForLinearAd: action,
			adStampEvent: action,
			errorEvent: action,
			_checkEventAsync: action,
			_openStreamRollingBufferAsync: action,
			contentEndPosition: observable,
			checkNonBvChannel: action
		})
		//console.debug("new SourceAbstact", this, parent)

		// MTVW-847: close PIP on browser (back) button
		/* Doesn't work on Safari, close PIP in OverlayEventDetails setShow instead
		document.onmouseover = function () {
			// User's mouse is inside the page.
			window.innerDocClick = true
		}

		document.onmouseleave = function () {
			// User's mouse has left the page.
			window.innerDocClick = false
		}

		self = this
		window.onhashchange = function () {
			if (window.innerDocClick) {
				// Our own in-page mechanism triggered the hash change
			} else if (self.player.isInPip) {
				// Browser back button was clicked
				self.player.showPiP(false).then(() => {
					self.player.setRefElemContainer(null, true)
				})
			}
		}
		*/
	}

	// MTV-3570: set a lazy object here
	//mediaService = lazyObject(this, "mediaService", MediaService)
	mediaService = rootStore.mediaService

	// globals helper method
	/**
	 * @returns {import("store/page/player/visualon/PlayerVo.js").PlayerVo}
	 */
	get player() {
		//console.debug("_parent= %o", this._parent, this._parent.player, this._parent.player, this._parent._parent)
		// MTVW-788, MTVW-787: _player in source
		// Commented statement causes ads player issues
		//return this._player ? this._player : this._parent.player
		return this._parent.player
	}

	/**
	 * @returns {import("store/page/player/PlayerSettings").PlayerSettings}
	 */
	get settings() {
		return this._parent.settings
	}

	get Event() {
		// MTVW-487: replace traxis rootStore.api.GetEventByChannelTime with epgMS implementation
		return this.GetEvent
	}

	// methods
	get isStreamUrl() {
		return !!(this.playlist !== null ? this.playlist.getStreamUrl : false)
	}

	get getStreamUrl() {
		return this.playlist !== null ? this.playlist.getStreamUrl : null
	}

	get getDrmScheme() {
		return this.playlist !== null ? this.playlist.getDrmScheme : null
	}

	get getStreamUrlLicense() {
		return this.playlist !== null ? this.playlist.getStreamUrlLicense : null
	}

	get getStreamUrlCertificate() {
		return this.playlist !== null ? this.playlist.getStreamUrlCertificate : null
	}

	get isPosterUrl() {
		return !!posterUrl(this?.Event)
	}

	get getPosterUrl() {
		return this.isPosterUrl ? posterUrl(this?.Event) : null
	}

	// MTVW-725
	videoSnapshot() {
		// DRM could create SecurityError
		try {
			const canvas = document.createElement('canvas')
			const videoElem = 'vjs_' + this.player.idDomPlayer + '_html5_api'
			console.debug("videoElem=", videoElem, this._parent, this.player.idDomPlayer)
			let video = document.getElementById(videoElem)
			if (import.meta.env.VITE_PLAYER === "vo") {
				//console.debug("vop-video", document.getElementsByClassName("vop-video")[0])
				video = document.getElementsByClassName("vop-video")[0]
			}

			if (video) {
				canvas.width = 1920
				canvas.height = 1080
				const ctx = canvas.getContext('2d')
				ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
				this.setCapturedVideoImage(canvas.toDataURL('image/jpeg'))
				//console.debug("image captured", SourceAbstract.capturedVideoImage = image)
			}
		}
		catch (err) {
			console.error("videoSnapshot", err)
		}
	}

	setCapturedVideoImage(image) {
		SourceAbstract.capturedVideoImage = image
	}

	get capturedVideoImage() {
		return SourceAbstract.capturedVideoImage
	}

	isSourceEqual(source) {
		console.error("@(source=%o) this=%o NEED IMPLEMENTATION", source)
		return null
	}

	// buttons disable state
	get isButtonLiveEnabled() {
		return false
	}

	get isButtonReplayEnabled() {
		return false
	}

	get isButtonJumpFwdEnabled() {
		return false
	}

	get isButtonJumpRwdEnabled() {
		return false
	}

	get isButtonPlayPauseEnabled() {
		return this.player.isStreamLoaded
	}

	get isButtonRecEnabled() {
		return this.player.isStreamLoaded && appFeatures.traxisAvailable
	}

	// for live, replay and recordings
	get isButtonTrackAudioEnabled() {
		return !this.player.isTracksAudioEmpty && this.player.isStreamLoaded
	}

	// for live, replay and recordings
	get isButtonTrackSubtitleEnabled() {
		return !this.player.isTracksSubtitleEmpty && this.player.isStreamLoaded
	}

	// for live, replay and recordings
	get isButtonFullScreenEnabled() {
		return true
	}

	// buttons visible state
	// GT12: MTVW-460, MTVW-502: Channels MS flags, for live and replay
	get isButtonLiveHidden() {
		return false
	}

	// GT12: MTVW-460, MTVW-502: Channels MS flags, for live and replay
	get isButtonReplayHidden() {
		//console.debug("hasStartOver %o, %o", rootStore.channelsService?.getChannel(channelId(this.Event))?.hasStartOver, rootStore.channelsService?.getChannel(channelId(this.Event)))
		return !rootStore.channelsService?.getChannel(channelId(this.Event))?.hasStartOver || !this.msEpg?.isReplayAllowed(channelId(this.Event), startTs(this.Event), endTs(this.Event))
	}

	// GT12: MTVW-460: Channels MS flags, for live and replay
	get isButtonJumpFwdHidden() {
		//console.debug("hasForwardRewind %o, %o", rootStore.channelsService?.getChannel(channelId(this.Event))?.hasForwardRewind, rootStore.channelsService?.getChannel(channelId(this.Event)))
		return !rootStore.channelsService?.getChannel(channelId(this.Event))?.hasForwardRewind
	}

	// GT12: MTVW-460: Channels MS flags, for live and replay
	get isButtonJumpRwdHidden() {
		return !rootStore.channelsService?.getChannel(channelId(this.Event))?.hasForwardRewind
	}

	// GT12: MTVW-460: Channels MS flags, hasLivePause appies only to live
	get isButtonPlayPauseHidden() {
		return false
	}

	// GT12: MTVW-460: Channels MS flags, for live and replay
	get isButtonRecHidden() {
		//return !(rootStore.channelsService?.getChannel(channelId(this.Event))?.hasNPVR && this.msEpg?.isReplayAllowed(channelId(this.Event), startTs(this.Event), endTs(this.Event)))
		return !this.msEpg?.isRecordingAllowed(channelId(this.Event), startTs(this.Event), endTs(this.Event))
	}

	// for live, replay and recordings
	get isButtonTrackAudioHidden() {
		return false
	}

	// for live, replay and recordings
	get isButtonTrackSubtitleHidden() {
		return false
	}

	get isButtonFullScreenHidden() {
		return false
	}

	// MTVW-1081
	get isButtonMoreEpisodesHidden() {
		//console.debug("isButtonMoreEpisodesVisible", !!document.getElementById("moreEpisodesCarousel")?.checkVisibility())
		const isAvailale = !!document.getElementById("moreEpisodesCarousel")?.checkVisibility() && this.GetEvent?.moreEpisodes && this.GetEvent?.moreEpisodes?.length > 0
		return !isAvailale
	}

	get rangeEventMinTs() {
		return startTs(this.source.Event)
	}

	get rangeEventMaxTs() {
		return endTs(this.source.Event) ? Math.min(endTs(this.source.Event), rootStore.time.getTimeStamp() - this.player.streamLiveDelay) : 0
	}

	get MARKER_B() {
		return "start"
	}

	get MARKER_C() {
		return "skipStart"
	}

	get MARKER_D() {
		return "end"
	}

	// MTVW-1101: TODO check moreEpisodes in case of epg event
	get MARKER_N() {
		return "next"
	}

	latchedEpisodeInfo = {
		start: null,
		end: null,
		nextEpisodeId: null
	}

	resetlatchedEpisodeInfo() {
		this.latchedEpisodeInfo.start = null
		this.latchedEpisodeInfo.end = null
		this.latchedEpisodeInfo.nextEpisodeId = null
		this.latchedEpisodeInfo.eventStart = null
	}

	isEpisodePlayable(episodeId) {
		const episode = this.Event?.moreEpisodes?.find(i => i.id === episodeId)
		return episode ? Number(episode.start) <= moment().utc().valueOf() : false
	}

	get nextEpisodeInfo() {
		// update this.latchedEpisodeInfo
		//const startOffset = this.isBvChannel(this.Event?.event?.channelId) ? 0 : -10000 + 2000 // 2s compensation
		const chId = channelId(this.Event?.event)
		const srfIds = ["2021", "2023", "2030"]
		let startOffset = -30000
		if (srfIds.includes(chId)) startOffset = -90000
		//console.debug("nextEpisodeInfo", chId, startOffset)
		//const endOffset = this.isBvChannel(this.Event?.event?.channelId) ? 30000 : 20000 + 2000 // 2s compensation
		const endOffset = 5000
		if (this.latchedEpisodeInfo.eventStart && this.player?.positionTimeStamp < this.latchedEpisodeInfo.eventStart) {
			//console.debug("trigger for reset")
			this.resetlatchedEpisodeInfo()
			return this.latchedEpisodeInfo
		}
		if (!this.latchedEpisodeInfo.start || !this.latchedEpisodeInfo.end || !this.latchedEpisodeInfo.nextEpisodeId) {
			if (this.contentEndPosition && this.Event?.nextEpisodeId && this.type !== SourceTypeList.ChannelLive) {
				console.debug("eventIds", chId, eventId(this.Event.event), this.Event?.nextEpisodeId, this.player._parent.source)
				// validate that next episode is not in the future
				if (this.isEpisodePlayable(this.Event?.nextEpisodeId)) {
					console.debug("nextEpisodeButtonStart", this.contentEndPosition + startOffset, moment(this.contentEndPosition + startOffset).utc().format(TIME_FORMAT_BACKEND))
					this.latchedEpisodeInfo.start = this.contentEndPosition + startOffset
					this.latchedEpisodeInfo.end = this.contentEndPosition + endOffset
					this.latchedEpisodeInfo.nextEpisodeId = this.Event?.nextEpisodeId
					this.latchedEpisodeInfo.eventStart = startTs(this.Event.event)
					return this.latchedEpisodeInfo
				}
				else {
					console.warn("next episode in future")
					this.resetlatchedEpisodeInfo()
					return this.latchedEpisodeInfo
				}
			}
			//endTs(this.Event?.event) ? endTs(this.Event?.event) - 10000 : null
			else {
				this.resetlatchedEpisodeInfo()
				if (this.isEpisodePlayable(this.Event?.nextEpisodeId)) this.latchedEpisodeInfo.nextEpisodeId = this.Event?.nextEpisodeId
				return this.latchedEpisodeInfo
			}
		}
		else {
			if (this.player?.positionTimeStamp > this.latchedEpisodeInfo.end) {
				this.resetlatchedEpisodeInfo()
				if (this.isEpisodePlayable(this.Event?.nextEpisodeId)) {
					this.latchedEpisodeInfo.nextEpisodeId = this.Event?.nextEpisodeId
					this.latchedEpisodeInfo.eventStart = startTs(this.Event.event)
				}
			}
			return this.latchedEpisodeInfo
		}
	}

	debounced() {
		// debounce potential multiple clicks
		if (this.debounceEvent) return false
		this.debounceEvent = true
		setTimeout(() => {
			this.debounceEvent = false
		}, 50)
		return true
	}

	// Branchenvereinbarung (GT12 or Caipy) channel
	// MTVW-983, MTVW-985, MTVW-986, MTVW-993
	isBvChannel(channel) {
		const ch = rootStore.channelsService?.getChannel(channel)
		const result = appFeatures.gt12Enabled && serviceUrls.isAdsMsAvailable && (ch?.hasAlternativeAds || ch?.hasAdSkipping)
		//console.debug("isBvChannel %s, %s", channel, result, ch)
		return result
	}

	// only valid for GT12 and Caipy channels
	// MTVW-983, MTVW-985, MTVW-986, MTVW-993
	hasPremium(channel) {
		const ch = rootStore.channelsService?.getChannel(channel)
		const result = appFeatures.gt12Enabled && serviceUrls.isAdsMsAvailable && ch?.hasAdSkipping && ch?.hasMarkers
		return result
	}

	// GT12 and Caipy
	// MTVW-983, MTVW-985, MTVW-986, MTVW-993
	hasReplayPremiumButton(channel) {
		const ch = rootStore.channelsService?.getChannel(channel)
		const result = appFeatures.gt12Enabled && serviceUrls.isAdsMsAvailable && !ch?.hasAdSkipping && ch?.hasMarkers
		//console.debug("hasReplayPremiumButton", ch, result)
		return result
	}

	_isZoneInCurrentShow(adZone, marker) {
		return (Number(adZone[marker]) >= startTs(this.Event) && Number(adZone[marker]) <= endTs(this.Event))
	}

	_firstZoneInCurrentShow(marker) {
		let firstZone = null
		this.sessionAdZones?.adZones?.forEach(i => {
			if (this._isZoneInCurrentShow(i, marker)) {
				if (!firstZone) firstZone = i
			}
		})
		return firstZone
	}

	hasAdZone(channel, marker) {
		//console.debug("hasAdZone %o, %o, %o, %o", this.isBvChannel(channel), channel, this.type, this.sessionAdZones)
		if (this.isBvChannel(channel) && this.type !== SourceTypeList.ChannelLive && this.sessionAdZones && this.sessionAdZones?.adZones?.length > 0) {
			let inCurrentShow = false
			this.sessionAdZones?.adZones?.forEach(i => {
				if (this._isZoneInCurrentShow(i, marker)) {
					inCurrentShow = true
					//console.debug("hasAdZone %s, %s", moment(Number(i.start)).utc().format(TIME_FORMAT_BACKEND), moment(Number(i.end)).utc().format(TIME_FORMAT_BACKEND))
				}
			})
			return inCurrentShow
		}
		else return false
	}

	nearestMarker(marker) {
		//console.debug("MARKER %o", marker)
		const currentPos = this.player?.positionTimeStamp
		let nearestZone = null
		let nearestDiff = Number.MAX_SAFE_INTEGER
		this.sessionAdZones?.adZones?.forEach(i => {
			if (this._isZoneInCurrentShow(i, marker)) {
				const diff = Number(i[marker]) - currentPos
				//console.debug("%o, %o", i, i[marker])
				if (diff > 0 && diff < nearestDiff) {
					nearestDiff = diff
					nearestZone = i
				}
			}
		})
		// TODO: fetch next by using this.sessionAdZones.nextPositionToCheck ?
		//return nearestZone ? nearestZone[marker] : this.sessionAdZones?.adZones[0][marker]
		const firstZone = this._firstZoneInCurrentShow(marker)
		return nearestZone ? Number(nearestZone[marker]) : firstZone ? Number(firstZone[marker]) : null
	}

	// player controls
	setPlayPause() {
		console.log("@")
	}

	startPauseAd() {
		this.adPauseStart = performance.now()
	}

	removePauseAd(closeInteraction = "resume") {
		if (this.pauseAd && this.adPauseStart !== 0) {
			//console.debug("PAUSE AD DISPLAYED %s", Math.round(performance.now() - this.adPauseStart))
			// GT12: special cases are handled in interactionEvent
			// closeInteraction: [ resume, close, changeAsset, interruption ] or "" for no interaction
			// error: [ adNotFound, other ] or ""  for no error
			try {
				this.adsService.sessionTrackingPauseAdAsync(this.sessionId, this.pauseAd.adsViewId, Math.round(performance.now() - this.adPauseStart), closeInteraction, "")
			}
			catch (e) {
				console.error("removePauseAd error %o", e)
				rootStore.logService.logAsync(logLevel.Error, "removePauseAd", "SourceAbstract", e)
			}
		}
		this.adPauseStart = 0
		this.pauseAd = null
	}

	// check for ad url and pre-fetch it (will be cached by the browser), error handling
	checkPauseAd(pauseAd) {
		// MTVW-519: test purpose
		//pauseAd.adUrl = "https://quickline.ch/any.jpg"
		//pauseAd.adUrl = null
		//console.debug("checkPauseAd", pauseAd?.adUrl)
		if (!pauseAd?.adUrl) {
			this.pauseAd = null
			console.error(`no pauseAd.adUrl`)
			rootStore.logService.logAsync(logLevel.Error, `no pauseAd.adUrl`, "SourceAbstract")
		}
		else {
			fetch(pauseAd.adUrl).then(() => {
				runInAction(() => {
					if (this.player.isPaused) this.pauseAd = pauseAd
				})
			}).catch((e) => {
				runInAction(() => {
					this.pauseAd = pauseAd
				})
				console.error(`pauseAd fetch '${pauseAd.adUrl}' failed`, e)
				rootStore.logService.logAsync(logLevel.Error, `pauseAd fetch "${pauseAd.adUrl}" failed`, "SourceAbstract", e)
			})
		}
	}

	setPauseAd() {
		// GT12
		const chId = channelId(this.Event)
		if (!this.__parent.isAdsPlayer && this.isBvChannel(chId) && this.sessionId) {
			this.pauseAd = null
			let AvailabilityStartTs = startTs(this.Event)
			this.adsService.sessionPauseAsync(this.sessionId, chId, AvailabilityStartTs, this.player?.positionTimeStamp).then((result) => {
				runInAction(() => {
					// MTVW-519
					//this.pauseAd = result?.pauseAd
					this.checkPauseAd(result?.pauseAd)
				})
				//console.debug("PAUSE %o, %o", this.pauseAd, this)
			}).catch((e) => {
				console.error("setPauseAd error %o", e)
				rootStore.logService.logAsync(logLevel.Error, "setPauseAd", "SourceAbstract", e)
			})
		}
	}

	setReplayAdInfo(info) {
		this.replayAdInfo = info
		if (!info) this.adState.replay = null
	}

	setFfwdAdInfo(info) {
		//console.trace("setFfwdAdInfo", info)
		this.fastForwardAdInfo = info
		if (!info) this.adState.fastFwd = null
		// MTVW-779: prevent showing fast forward button
		else this.adState.linear = null
	}

	setJumpLive() {
		console.log("@")
	}

	setJumpRwd() {
		console.log("@")
	}

	setJumpFwd() {
		console.log("@")
	}

	setJumpMarker(marker) {
		let markerPos = this.nearestMarker(marker)
		// MTVW-1101
		if (marker === this.MARKER_N) {
			markerPos = this.nextEpisodeInfo?.start ?? null
			//console.debug("setJumpMarker", moment(this.nextEpisodeInfo?.start).utc().format(TIME_FORMAT_BACKEND))
			//this.contentEndPosition = null
		}
		else if (marker === this.MARKER_D) this.markerPosD = markerPos ? Number(markerPos) : null
		else this.markerPosD = null
		if (markerPos) this.handleSetPosition(moment(Number(markerPos)).utc()) //this.player.setPositionTimeStamp(markerPos)
	}

	setRestart() {
		console.log("@")
	}

	setFullScreen = flow(function* (bState, cinemaMode = false) {
		console.log("@(bState=%o)", bState)
		yield this.player.setFullScreen(bState, cinemaMode)
	})

	showPiP(enable) {
		this.player.showPiP(enable)
	}

	// MTV-3570
	/* MTVW-1096: use CoCo
	_setupStream = flow(function* (urlSuffix, channelId) {
		//console.debug("_setupStream", urlSuffix)
		const jsonStreamReply = yield this.mediaService.setupStream(urlSuffix, channelId)
		//console.debug("jsonStreamReply %o", jsonStreamReply)
		//console.debug("_setupStream", this.player)
		// MTVW-725 session timeout, case of active ads
		const player = this.__parent.isAdsPlayer ? this._player : this.player
		//console.debug("_setupStream", jsonStreamReply)
		yield this.playlist.setStreamInfo(jsonStreamReply, this.id, this.mediaService, player)
	})
	*/

	// MTVW-1096: use specific CoCo methods
	_setupLiveStream = flow(function* (channelId) {
		const streamInfo = yield this.mediaService.setupLiveStreamAsync(channelId)
		//console.debug("_setupLiveStream", streamInfo)
		const player = this.__parent.isAdsPlayer ? this._player : this.player
		yield this.playlist.setStreamInfo(streamInfo, this.id, this.mediaService, player)
	})

	_setupReplayStream = flow(function* (channelId, startTime, endTime) {
		const streamInfo = yield this.mediaService.setupReplayStreamAsync(channelId, startTime, endTime)
		//console.debug("_setupLiveStream", streamInfo)
		const player = this.__parent.isAdsPlayer ? this._player : this.player
		yield this.playlist.setStreamInfo(streamInfo, this.id, this.mediaService, player)
	})

	_setupRecordingStream = flow(function* (channelId, startTime, endTime, recordingId) {
		const streamInfo = yield this.mediaService.setupRecordingStreamAsync(channelId, startTime, endTime, recordingId)
		//console.debug("_setupLiveStream", streamInfo)
		const player = this.__parent.isAdsPlayer ? this._player : this.player
		yield this.playlist.setStreamInfo(streamInfo, this.id, this.mediaService, player)
	})

	_openStreamLiveAsync = flow(function* () {
		cDebug("@@_openStreamLiveAsync() ->", this.Event)
		// MTVW-1075
		const chId = channelId(this.Event)
		if (!chId) {
			console.error("no ChannelId", this.Event)
			return
		}
		// MTV-3570: No need to create traxis playlist anymore
		// fetch BKM URL for Playlist from Traxis (this checks entitlement of user + IP geolocation)
		//yield Promise.all([this._fetchEventAsync(), this._fetchPlaylistChannelAsync(chId)])
		// GT12 TODO: obsolete since Media MS ?
		yield this._fetchEventAsync()
		// MTVW-1096: use CoCo
		//yield this._setupStream(`live/${chId}`, chId)
		yield this._setupLiveStream(chId)
		this.playlistLoadedCallback()

		// GT12, could be alternatively in Player.setPlayChannelLiveAsync
		if (this.isBvChannel(chId)) {
			try {
				const result = yield this.adsService.startLiveAsync(chId, startTs(this.Event), endTs(this.Event))
				// timeout exception will be caught
				this.sessionId = result?.sessionId ?? null
				//console.debug("startLiveAsync %o, SourceAbstract %o", result, this)
				this.sessionAdZones = yield this.getAdZones(startTs(this.Event), endTs(this.Event), this.player?.positionTimeStamp)
				//yield this.adsService.configurePauseMockAsync(false)
				this.sessionEnd = startTs(this.Event.event)
			} catch (e) {
				console.error("_openStreamLiveAsync error %o", e)
				rootStore.logService.logAsync(logLevel.Error, "_openStreamLiveAsync", "SourceAbstract", e)
			}
		}

		yield this.player.setSource(this).openStreamAsync()
		console.info("@@_openStreamLiveAsync() <-")
	})

	//enterAdsPlayer() {
	enterAdsPlayer = flow(function* () {
		yield this._parent.activateAdsPlayer()
	})

	//exitAdsPlayer() {
	exitAdsPlayer = flow(function* () {
		yield this.__parent.deactivateAdsPlayer()
		// ensure to update adZones
		setTimeout(() => {
			this.getAdZones(startTs(this.Event), endTs(this.Event), this.player?.positionTimeStamp).then((result) => {
				runInAction(() => { this.sessionAdZones = result; cDebug("exitAdsPlayer NEW AD ZONES %o", this.sessionAdZones) })
			}).catch((e) => {
				console.error("exitAdsPlayer OOPS %o, %o", e, this.Event)
			})
		}, 1000)
	})

	actionBeforeReplayAd = (startPosition) => {
		// preload stream
		this.player.setSource(this).openStreamAsync(true, startPosition)//.then((result) => {
	}

	//actionAfterReplayAd = (error = "", playbackStamp = null) => {
	actionAfterReplayAd = flow(function* (error = "", playbackStamp = 0, metaDuration = 0, playTime = 0) {
		//console.debug("DEACTIVATE %o", this, this.__parent)
		try {
			yield this.exitAdsPlayer()
			/*
			this.player.setSource(this).openStreamAsync().then((result) => {
				this.player.setIsPosterVisible(false)
				this.player.setPlayPause()
			})
			*/
			// start preloaded stream
			this.player.setIsPosterVisible(false, "actionAfterReplayAd")
			// PRELOAD: if stream is not yet preloaded we'll start to play in preloadEvent()
			if (this.player.isPaused) yield this.player.setPlay("actionAfterReplayAd")
			// GT12: special cases are handled in interactionEvent
			// closeInteraction: [ changeAsset, interruption ] or "" for no interaction
			// error: [ adNotFound, other ] or ""  for no error
			//console.debug("actionAfterReplayAd %s, %o, %o, %o", error, this.adsService, this.adPlayStart, this)
			//const duration = playbackStamp === null ? moment().valueOf() - this.adPlayStart : playbackStamp - this.adPlayStart
			const duration = playTime >= metaDuration ? playTime : metaDuration > 0 ? metaDuration : moment().utc().valueOf() - this.adPlayStart
			console.debug("AD ENDED", metaDuration, playTime, duration, playbackStamp, this.adPlayStart, moment().utc().valueOf() - this.adPlayStart)
			if (this.sessionId) yield this.adsService.sessionTrackingReplayAdAsync(this.sessionId, this.replayAdInfo?.replayAd?.adsViewId, Math.round(duration), "", error)
		}
		catch (e) {
			this.setReplayAdInfo(null)
			console.error("actionAfterReplayAd error %o", e)
			try {
				yield rootStore.logService.logAsync(logLevel.Error, "actionAfterReplayAd", "SourceAbstract", e)
			}
			catch (err) {
				console.errror("actionAfterReplayAd logAsync", err)
			}
		}
		this.setReplayAdInfo(null)
	})

	// GT12 TODO: factor out common code with _startReplaySession
	_contentReplay = flow(function* () {
		let rsp = null
		let adPlayed = false
		this.trueReplaySession = true
		// MTVW-495
		this.sessionStart = startTs(this.Event)
		// MTVW-725 session timeout, case of active ads
		const player = this.__parent.isAdsPlayer ? this._player : this.player
		//debugger
		try {
			if (/*this.trueReplaySession &&*/ this.isBvChannel(channelId(this.Event)) /*&& !this.sessionId*/) {
				const event = this.Event
				const recInfo = yield this._getRecordingInfo(eventId(event), seriesId(event)?.content?.SeriesId)
				// (channelId, recordingId, epgEventStart, isSeriesRecording, replayWindow, bookmarkPosition, bookingTime, retryCount = 1)
				// GT12 TODO: bookmarkPosition ?
				//rsp = yield this.adsService.startRecordingAsync(channelId(event), recInfo?.recordingId, startTs(event), endTs(event), recInfo?.isSeries, moment.duration(this.playlist.StreamInfo.streamLifetime, moment.ISO_8601).valueOf(), 0, recInfo?.bookingTime)
				rsp = yield this.adsService.startRecordingAsync(channelId(event), recInfo?.recordingId, startTs(event), endTs(event), recInfo?.isSeries, moment.duration(rootStore.channelsService?.getChannel(channelId(this.Event))?.maxReplayDuration, moment.ISO_8601).valueOf(), null, recInfo?.bookingTime)
				this.contentEndPosition = rsp?.contentEndPosition ? Number(rsp?.contentEndPosition) : null
				// MTVW-495
				this.sessionStart = rsp?.contentStartPosition ? Number(rsp?.contentStartPosition) : this.sessionStart
				this.sessionId = rsp?.sessionId ?? null
				cDebug("_contentReplay startRecordingAsync %o", rsp)
				this.sessionAdZones = yield this.getAdZones(startTs(event), endTs(event), player?.positionTimeStamp)
				this.sessionEnd = endTs(event)
				// MTVW-1101
				this.contentEndPosition = rsp?.contentEndPosition ? Number(rsp?.contentEndPosition) : null
			}
			if (this.trueReplaySession && !this.restartDone) {
				rsp = yield this.handleReplayAd(rsp, this.contentReplayActionBeforeReplayAd, this.actionAfterReplayAd)
				adPlayed = true
				//this.trueReplaySession = false
			}
		}
		catch (e) {
			player.setPositionTimeStamp(this.sessionStart)
			console.error("_contentReplay error %o", e)
			rootStore.logService.logAsync(logLevel.Error, "_contentReplay", "SourceAbstract", e)
			return
		}
		// rsp will be null in case ads MS doesn't return an ad
		if (!adPlayed || !rsp) {
			// MTVW-495
			// VJS: below statement is needed
			yield player.setPositionTimeStampAsync(this.sessionStart)
		}
	})

	// NOT USED
	checkNonBvChannel() {
		/*
		console.debug("checkNonBvChannel entry mode %s, cEnd %s, neId %s",
			this.Event?.mode, this.contentEndPosition ? moment(this.contentEndPosition).utc().format(TIME_FORMAT_BACKEND) : null,
			this.Event?.nextEpisodeId)
		*/
		if (this.Event?.mode === CoCo.EventDetailsMode.Full) {
			if ((!this.Event.nextEpisodeId || !this.contentEndPosition) && this.Event?.moreEpisodes?.length > 0) {
				let index = this.Event?.moreEpisodes?.findIndex(j => j.id === this.Event?.event?.id)
				if (index >= 0 && (index + 1 < this.Event?.moreEpisodes?.length)) {
					index++
					if (moment(Number(this.Event?.moreEpisodes?.[index]?.start)).utc().valueOf() < moment().utc().valueOf()) {
						if (!this.contentEndPosition) this.contentEndPosition = this.Event?.event?.endMillis ? Number(this.Event?.event?.endMillis) /*- 10000*/ : null
						if (!this.Event?.nextEpisodeId) this.GetEvent.nextEpisodeId = this.Event?.moreEpisodes?.[index]?.id
						/*
						console.debug("checkNonBvChannel", index, this.Event?.event?.id, this.Event?.moreEpisodes,
							this.Event?.moreEpisodes?.[index+1].id, this.Event?.moreEpisodes?.[index+1].start,
							moment(Number(this.Event?.moreEpisodes?.[index+1].start)).utc().valueOf() < moment().utc().valueOf())
						*/
					}
				}
				console.debug("checkNonBvChannel cEnd %s, neId %s",
					this.contentEndPosition ? moment(this.contentEndPosition).utc().format(TIME_FORMAT_BACKEND) : null, this.Event?.nextEpisodeId)
			}
		}
	}

	_startReplaySession = flow(function* (startTime = null, endTime = null, sessionId = null, playReplayAd = true) {
		//console.trace("_startReplaySession=")
		// MTVW-725 session timeout, case of active ads
		const player = this.__parent.isAdsPlayer ? this._player : this.player
		try {
			//console.debug("trueReplaySession %s, isAdsMsAvailable %s, sessionId %s", this.trueReplaySession, this.isBvChannel(channelId(this.Event)), this.sessionId)
			// GT12
			let rsp = null
			let adPlayed = false
			this.sessionStart = startTime
			// MTVW-816
			const bookmark = yield rootStore.page.CoCoBookmarks.getBookmarkAsync(this.Event, false)
			this.bmPos = bookmark?.position
			//debugger
			// NO startReplayAsync when switching from live with positioning, only on restart
			//console.debug("isBvChannel", this.trueReplaySession, this.isBvChannel(channelId(this.Event)), sessionId)
			// MTVW-1101
			if (this.isBvChannel(channelId(this.Event))) {
				rsp = yield this.adsService.startReplayAsync(channelId(this.Event), moment(startTime).utc().valueOf(), moment(endTime).utc().valueOf(), this.bmPos)
				this.contentEndPosition = rsp?.contentEndPosition ? Number(rsp?.contentEndPosition) : null
			}
			if (this.trueReplaySession && this.isBvChannel(channelId(this.Event)) && !sessionId) {
				// MTVW-816: bookmarkPosition
				// MTVW-1101: moved above
				//rsp = yield this.adsService.startReplayAsync(channelId(this.Event), moment(startTime).utc().valueOf(), moment(endTime).utc().valueOf(), this.bmPos)
				// timeout exception will be caught
				this.sessionId = rsp?.sessionId ?? null
				cDebug("startReplayAsync %o, SourceAbstract %o, trueReplaySession %s", rsp, this, this.trueReplaySession)
				this.sessionAdZones = yield this.getAdZones(moment(startTime).utc().valueOf(), moment(endTime).utc().valueOf(), this.player?.positionTimeStamp)
				// MTVW-495: use contentStartPosition for starting stream
				// don't use returned bookmark position, setReplay would start again at the bookmark
				if (!this.bmPos) this.sessionStart = rsp?.contentStartPosition ? Number(rsp?.contentStartPosition) : this.sessionStart
				this.sessionEnd = moment(endTime).utc().valueOf()
			}
			cDebug("---trueReplaySession %o, restartDone %o, bmPos %o, adZones %o, %o, %o, %o", this.trueReplaySession, this.restartDone, this.bmPos, this.sessionAdZones, this, this.Event)
			if (!this.bmPos && this.trueReplaySession && !this.restartDone && playReplayAd) {
				rsp = yield this.handleReplayAd(rsp, this.actionBeforeReplayAd, this.actionAfterReplayAd)
				adPlayed = true
				//this.trueReplaySession = false
			}
			// rsp will be null in case ads MS doesn't return an ad
			if (!adPlayed || !rsp) {
				//this.exitAdsPlayer()
				if (playReplayAd) {
					this.setReplayAdInfo(null)
					/**/
					// MTVW-495
					//yield this.player.setSource(this).openStreamAsync()
					yield player.setSource(this).openStreamAsync(true, this.bmPos ? this.bmPos : this.sessionStart)
					//if (this.player.isPaused) yield this.player.setPlay("playReplayAd")
					// TODO VJS: recheck if needed
					/* MTVW-725: commented
					if (import.meta.env.VITE_PLAYER === "vo") {
						this.player.setPositionTimeStamp(this.sessionStart)
					}
					*/
					player.setPositionTimeStamp(this.bmPos ? this.bmPos : this.sessionStart)
					/**/
				}
			}
			cDebug("_startReplaySession GOT %o, %o", rsp, this._parent, this, this.player)
		}
		catch (e) {
			console.error("_startReplaySession error %o", e)
			this.setReplayAdInfo(null)
			yield player.setSource(this).openStreamAsync()
			rootStore.logService.logAsync(logLevel.Error, "_startReplaySession", "SourceAbstract", e)
		}
	})

	// MTVW-1096: replay stream start performance improvement, replaces _openStreamRollingBufferAsync
	// startTime: replay start position
	_openReplayStreamAsync = flow(function* (event, startPosition = null) {
		//console.debug("_openReplayStreamAsync event %o, startPosition %o, source time %o", event, startPosition, this.time)
		let eventStartTs = startTs(event)
		let startTime = moment(eventStartTs).utc().format(TIME_FORMAT_BACKEND)
		const eventEndTs = endTs(event)
		const endTime = moment(eventEndTs).utc().format(TIME_FORMAT_BACKEND)
		let eventTimeTs = null
		let eventTime = null
		if (startPosition) {
			eventTimeTs = moment(startPosition).utc().valueOf()
			eventTime = moment(eventTimeTs).utc().format(TIME_FORMAT_BACKEND)
			if (eventTimeTs < eventStartTs || eventTimeTs > eventEndTs) {
				// MTVW-1096: TODO / CHECK why would this happen?
				console.warn("_openReplayStreamAsync", eventTime, "<?", startTime, eventTime, ">?", endTime)
				debugger
			}
			else {
				eventStartTs = eventTimeTs
				startTime = eventTime
			}
		}
		console.debug("_openReplayStreamAsync event %o, eventStart %s, eventEnd %s, eventTime %o, source time %o",
			event, startTime, endTime, eventTime, this.time)

		const dbgInitial = { eventTime: eventTime, eventStart: startTime, eventEnd: endTime }

		// propagate potential media service exception (see BDD test replay Zermatt HD, otherwise wrong message is displayed)
		// GT12: MTVW-460, MTVW-502: Channels MS flags
		const allowedSince = moment(this.msEpg?.replayOrRecordingAllowedSince(channelId(event), eventStartTs, eventEndTs, false)).utc().valueOf()
		if (allowedSince > eventStartTs) {
			// MTVW-822: caused errors, why was there 1 hour added?
			// -> see 'Traxis RollingBuffer streams have an extra hour prepended' above, not anymore with mediaMS
			//startTime = moment(allowedSince + 3600 * 1000).utc().format(TIME_FORMAT_BACKEND)
			startTime = moment(allowedSince).utc().format(TIME_FORMAT_BACKEND)
			console.debug("_openReplayStreamAsync allowedSince startTime %o", startTime)
		}

		const dbgComputed = { eventTime: eventTime, startTime: startTime, endTime: endTime, allowedSince: moment(allowedSince).utc().format(TIME_FORMAT_BACKEND) }
		try {
			const channel = rootStore.channelsService?.getChannel(channelId(event))
			console.debug("_openReplayStreamAsync channel %s, hasReplay %s, maxReplay %o", channelId(event), channel?.hasReplay, channel?.maxReplayDuration)
			console.debug("_openReplayStreamAsync initial %o, computed %o, event %o", dbgInitial, dbgComputed, event)
			// MTVW-822, MTVW-823: last resort, generate error message
			if (moment(startTime).utc().valueOf() >= moment(endTime).utc().valueOf() || moment(startTime).utc().valueOf() > moment().utc().valueOf()) {
				rootStore.page.Player.error = ErrorBase.CreateError([l10n.featurePlayerErrorUnexpectedMessageWeb + ` (s ${startTime}, e ${endTime}, a ${moment(allowedSince).utc().format(TIME_FORMAT_BACKEND)})`], null, this, "_openReplayStreamAsync")
				return
			}
			// MTVW-1096: use CoCo
			//yield this._setupStream(`replay/${channelId()}/start/${startTime}/end/${endTime}`, channelId(event))
			yield this._setupReplayStream(channelId(event), startTime, endTime)
		}
		catch (err) {
			console.error("_openReplayStreamAsync initial %o, computed %o, event %o, err %o", dbgInitial, dbgComputed, event, err)
			// would be ErrorBaseEvent if not thrown without showing text from MS
			throw err
		}
		this.playlistLoadedCallback()

		yield this._startReplaySession(moment(startTime).utc().valueOf(), moment(endTime).utc().valueOf(), this.sessionId, true)
	})

	// eventTime: event start, startTime: replay start position, endTime: event end
	_openStreamRollingBufferAsync = flow(function* (eventTime = null, startTime = null, endTime = null) {
		console.info("@@_openStreamRollingBufferAsync(eventTime=%o, startTime=%o) eventTime.dump()=%o startTime.dump()=%o ->", eventTime, startTime, moment(eventTime).dump(), moment(startTime).dump())

		console.debug("_openStreamRollingBufferAsync eventTime %o, startTime %o, endTime %o, Event %o, GetEvent %o", eventTime, startTime, endTime, this.Event, this.GetEvent)

		const dbgInitial = { eventTime: eventTime, startTime: startTime, endTime: endTime }

		// check that current event is the eventTime
		// moment(null) -> "Invalid date"
		// moment(undefined) -> now
		// momment("undefined") -> "Invalid date"
		if (eventTime !== undefined && moment(eventTime).isValid()) {
			// MTVW-822, MTVW-823: use getEventByChannelTime instead
			//yield this._checkEventAsync(eventTime)
			// TODO: BugSnag error with eventTime equal -10000 results with undefined channel
			this.GetEvent = yield this.msEpg?.getEventByChannelTime(this.channelId, moment(eventTime).utc().valueOf())
			console.debug("_openStreamRollingBufferAsync called getEventByChannelTime %o", this.Event)
		} else {
			// will define this.GetEvent if null with time now
			yield this._fetchEventAsync()
			console.debug("_openStreamRollingBufferAsync called _fetchEventAsync %o", this.Event)
		}

		// fight with 1 hour extra time and 10s for buffer init (legacy app)
		//if (startTime === null || startTime === undefined || startTime === "undefined") {
		if (startTime === undefined || !moment(startTime).isValid()) {
			startTime = startTs(this.Event)
			console.debug("_openStreamRollingBufferAsync startTime startTs = %o", startTime)
		}
		// MTVW-822, MTVW-823: Could be past the currently assigned event
		else {
			this.GetEvent = yield this.msEpg?.getEventByChannelTime(this.channelId, moment(startTime).utc().valueOf())
			// MTVW-822, MTVW-823: set endTime
			// CAUTION: Recheck if that works always correctly and it's not starTime
			endTime = endTs(this.Event)
			console.debug("_openStreamRollingBufferAsync endTime = endTs %o", endTime)
		}

		if (!startTime) {
			//	throw new Error("Cannot calculate time for event")
			console.error("_openStreamRollingBufferAsync Cannot calculate time for event")
			return false
		}
		// MTV-3570
		//if (endTime === null || endTime === undefined || endTime === "undefined") {
		if (endTime === undefined || !moment(endTime).isValid()) {
			endTime = endTs(this.Event)
			console.debug("_openStreamRollingBufferAsync endTime = endTs %o", endTime)
		}

		// MTV-3570: Need to format time
		startTime = moment(startTime).utc().format(TIME_FORMAT_BACKEND)
		endTime = moment(endTime).utc().format(TIME_FORMAT_BACKEND)
		// MTVW-822, MTVW-823: commented
		//const originalStartTime = startTime

		// VO PLAYER SYNC
		// ATTENTION: this causes issues whith playCompleted (bufferEnd) events (on VO)
		// with long replays when positioning the stream after 4 hours.
		// In this case the bufferEnd event is not handled correctly
		/*
		if (import.meta.env.VITE_PLAYER === "vjs") {
			// OPTIMIZATION for SourceChannelReplay.setReplay (currently only for non GT12 channels)
			if (!this.isBvChannel(this.channelId && eventTime)) {
				eventTime = moment(eventTime).utc().format(TIME_FORMAT_BACKEND)
				startTime = eventTime
			}
		}
		*/

		//const firstChunkOffestSec = 10
		//startTime = startTime.add(firstChunkOffestSec, "seconds")  // 10s offset borrowed from old apps
		//console.debug("_openStreamRollingBufferAsync fixed startTime=%o ->", startTime.dump())

		// fetch BKM URL for Playlist from Traxis (this checks entitlement of user + IP geolocation)
		// Traxis RollingBuffer streams have an extra hour prepended

		// MTV-3570: No need to create traxis playlist anymore
		// yield this._fetchPlaylistRollingBufferAsync(this.Channel?.RollingBuffers?.getBufferId, startTime)

		// propagate potential media service exception (see BDD test replay Zermatt HD, otherwise wrong message is displayed)
		// GT12: MTVW-460, MTVW-502: Channels MS flags
		const allowedSince = moment(this.msEpg?.replayOrRecordingAllowedSince(channelId(this.Event), startTs(this.Event), endTs(this.Event), false)).utc().format(TIME_FORMAT_BACKEND)
		if (allowedSince > moment(startTime).utc().valueOf()) {
			// MTVW-822: caused errors, why was there 1 hour added?
			// -> see 'Traxis RollingBuffer streams have an extra hour prepended' above, not anymore with mediaMS
			//startTime = moment(allowedSince + 3600 * 1000).utc().format(TIME_FORMAT_BACKEND)
			startTime = allowedSince
			console.debug("_openStreamRollingBufferAsync allowedSince startTime %o", startTime)
		}
		//console.debug("allowedSince", allowedSince, startTime, startTs(this.Event))
		//console.debug("start %o, end %o, dur %o", moment(startTime).utc().valueOf(), moment(endTime).utc().valueOf(), moment(endTime).utc().valueOf() - moment(startTime).utc().valueOf())

		const dbgComputed = { eventTime: eventTime, startTime: startTime, endTime: endTime, allowedSince: allowedSince }
		try {
			const channel = rootStore.channelsService?.getChannel(channelId(this.Event))
			console.debug("_openStreamRollingBufferAsync channel %s, hasReplay %s, maxReplay %o", channelId(this.Event), channel?.hasReplay, channel?.maxReplayDuration)
			console.debug("_openStreamRollingBufferAsync initial %o, computed %o, event %o", dbgInitial, dbgComputed, this.Event)
			// MTVW-822, MTVW-823: last resort, generate error message
			if (moment(startTime).utc().valueOf() >= moment(endTime).utc().valueOf() || moment(startTime).utc().valueOf() > moment().utc().valueOf()) {
				rootStore.page.Player.error = ErrorBase.CreateError([l10n.featurePlayerErrorUnexpectedMessageWeb + ` (s ${startTime}, e ${endTime}, a ${allowedSince})`], null, this, "_openStreamRollingBufferAsync")
				return
			}
			// MTVW-1096: use CoCo
			//yield this._setupStream(`replay/${channelId(this.Event)}/start/${startTime}/end/${endTime}`, channelId(this.Event))
			yield this._setupReplayStream(channelId(this.Event), startTime, endTime)
		}
		catch (err) {
			console.error("_openStreamRollingBufferAsync initial %o, computed %o, event %o, err %o", dbgInitial, dbgComputed, this.Event, err)
			// would be ErrorBaseEvent if not thrown without showing text from MS
			throw err
		}
		this.playlistLoadedCallback()

		// GT12
		// _startReplaySession sets this.sessionStart
		// VO PLAYER SYNC
		// MTVW-822, MTVW-823: commented
		/*
		if (import.meta.env.VITE_PLAYER === "vjs") {
			// OPTIMIZATION for SourceChannelReplay.setReplay (currently only for non GT12 channels)
			if (!this.isBvChannel(this.channelId && eventTime)) startTime = originalStartTime
		}
		*/
		yield this._startReplaySession(moment(startTime).utc().valueOf(), moment(endTime).utc().valueOf(), this.sessionId, true)

		// move one hour without 10s
		//yield this.player.setSource(this).openStreamAsync()
		console.info("@@_openStreamRollingBufferAsync(eventTime=%o, startTime=%o)", moment(eventTime).dump(), moment(startTime).dump())
	})

	_getRecordings(props) {
		return this._root.api.GetRecordings({ ...{ isRecorded: true, isPlanned: true, iLimit: 2000, isChildRecordings: true, isSortDesc: false }, ...props })
	}

	_getRecordingInfo = flow(function* (eventId, seriesId) {
		const marker = rootStore.page.Recordings.Manager.getMarker(eventId, seriesId)
		//console.debug("getRecordings %o, eId %o, sId %o, marker %o", this, eventId, seriesId, marker)
		if (marker) {
			const recs = this._getRecordings({ Ids: marker.id })
			//console.debug("isRecordedAsSingle", rootStore.page.Recordings.IndexPage.isRecordedAsSingle(eventId))
			yield recs.fetchDataAsync()
			//console.debug("RECORDINGS isSeriesD %s, isSeriesM %s, %o, %o, %o", recs.DataMain.isSeries, marker.isSeries, recs, recs.DataMain.CreateTime, moment(recs.DataMain.CreateTime).utc().valueOf())
			// MTVW-507: Use marker.isSeries instead of recs.DataMain.isSeries
			// MTV-555 NOTE: if a series is started for a pre-scheduled single recording the single recording will belong to the series
			//return { recordingId: marker.id, isSeries: recs.DataMain.isSeries, bookingTime: moment(recs.DataMain.CreateTime).utc().valueOf() }
			/*
			if (moment(recs.DataMain.CreateTime).utc().valueOf() < moment(recs.DataMain.StartTime).utc().valueOf()) {
				console.debug("potentially prescheduled")
			}
			*/
			return { recordingId: marker.id, isSeries: marker.isSeries, bookingTime: moment(recs?.DataMain?.CreateTime).utc().valueOf() }
		}
		return null
	})

	_openStreamContentAsync = flow(function* () {
		console.info("@@_openStreamContentAsync() ->")
		// MTV-3570: No need to create traxis playlist anymore
		//yield Promise.all([this._fetchEventAsync(), this._fetchPlaylistContentAsync(this.id)])
		yield this._fetchEventAsync()
		cDebug("_openStreamContentAsync event %o, %o", this.Event, this)
		// MTVW-834: add start and end
		const startTime = moment(startTs(this.Event)).utc().format(TIME_FORMAT_BACKEND)
		const endTime = moment(endTs(this.Event)).utc().format(TIME_FORMAT_BACKEND)
		// MTVW-1096: use CoCo
		//yield this._setupStream(`recording/${channelId(this.Event)}/start/${startTime}/end/${endTime}?recordingId=${this.id}`, channelId(this.Event))
		yield this._setupRecordingStream(channelId(this.Event), startTime, endTime, this.id)
		this.playlistLoadedCallback()

		// GT12
		/**/
		let rsp = null
		let adPlayed = false
		// MTVW-495
		this.sessionStart = startTs(this.Event)
		// MTVW-816
		const bookmark = yield rootStore.page.CoCoBookmarks.getBookmarkAsync(this.Event, false)
		this.bmPos = bookmark?.position
		if (this.bmPos) this.sessionStart = this.bmPos
		// MTVW-725 session timeout, case of active ads
		const player = this.__parent.isAdsPlayer ? this._player : this.player
		//debugger
		try {
			if (/*this.trueReplaySession &&*/ this.isBvChannel(channelId(this.Event)) && !this.sessionId) {
				const event = this.Event
				const recInfo = yield this._getRecordingInfo(eventId(event), seriesId(event))
				// GT12 TODO: bookmarkPosition ?
				// playlist.begin considers eventPrefix (eg. 5PT5M), playlist.end considers event_postfix (eg. 5PT5M)
				// MTVW-494: Don't start recording at epg event (before it was at pre-padding)
				//rsp = yield this.adsService.startRecordingAsync(channelId(event), recInfo?.recordingId, this.playlist.begin * 1000, this.playlist.end * 1000, recInfo?.isSeries, moment.duration(this.playlist.StreamInfo.streamLifetime, moment.ISO_8601).valueOf(), 0, recInfo?.bookingTime)
				//rsp = yield this.adsService.startRecordingAsync(channelId(event), recInfo?.recordingId, startTs(event), endTs(event), recInfo?.isSeries, moment.duration(this.playlist.StreamInfo.streamLifetime, moment.ISO_8601).valueOf(), 0, recInfo?.bookingTime)
				// MTVW-816: bookmarkPosition
				rsp = yield this.adsService.startRecordingAsync(channelId(event), recInfo?.recordingId, startTs(event), endTs(event), recInfo?.isSeries, moment.duration(rootStore.channelsService?.getChannel(channelId(this.Event))?.maxReplayDuration, moment.ISO_8601).valueOf(), this.bmPos, recInfo?.bookingTime)
				this.contentEndPosition = rsp?.contentEndPosition ? Number(rsp?.contentEndPosition) : null
				// timeout exception will be caught
				this.sessionId = rsp?.sessionId ?? null
				cDebug("startRecordingAsync %o, SourceAbstract %o", rsp, this)
				this.sessionAdZones = yield this.getAdZones(startTs(event), endTs(event), player?.positionTimeStamp)
				// MTVW-495
				if (!this.bmPos) this.sessionStart = rsp?.contentStartPosition ? Number(rsp?.contentStartPosition) : this.sessionStart
				this.sessionEnd = endTs(event)
			}
			// MTVW-725 session timeout, case of active ads, do not call handleReplayAd
			if (!this.bmPos && this.trueReplaySession && !this.__parent.isAdsPlayer) {
				rsp = yield this.handleReplayAd(rsp, this.actionBeforeReplayAd, this.actionAfterReplayAd)
				adPlayed = true
				//this.trueReplaySession = false
			}
		}
		catch (e) {
			this.setReplayAdInfo(null)
			yield player.setSource(this).openStreamAsync()
			console.error("_openStreamContentAsync error %o", e)
			rootStore.logService.logAsync(logLevel.Error, "_openStreamContentAsync", "SourceAbstract", e)
			return
		}
		// rsp will be null in case ads MS doesn't return an ad
		if (!adPlayed || !rsp) {
			//this.exitAdsPlayer()
			this.setReplayAdInfo(null)
			// MTVW-494: Don't start recording at epg event (before it was at pre-padding)
			//yield player.setSource(this).openStreamAsync()
			// MTVW-495
			// MTVW-633: condition for this.time added
			if (this.time) player.setSource(this).openStreamAsync(true, this.time)
			else player.setSource(this).openStreamAsync(true, this.sessionStart)
			//if (player.isPaused) yield player.setPlay("!adPlayed")
			//console.debug("pos= sessionStart", this.sessionStart)
			// TODO VJS: recheck if needed
			/* MTVW-725: commented
			if (import.meta.env.VITE_PLAYER === "vo") {
				player.setPositionTimeStamp(this.sessionStart)
			}
			*/
		}
		cDebug("_openStreamContentAsync GOT %o, %o", rsp, this._parent)

		//yield this.player.setSource(this).openStreamAsync()
		console.info("@@._openStreamContentAsync() <-")
	})

	// called perodically from page/player/Player when timestamp changes
	recordingEndReached = false
	_checkEventAsync = flow(function* (eventTime) {
		console.info(
			"@@_checkEventAsync(eventTime=%o %o) - this.Event=%o ...isTimeInEventRange=%o",
			eventTime,
			moment(eventTime).dump(),
			this.Event,
			isTimeInEventRange(eventTime, this.Event)
		)
		if (this.type === SourceTypeList.ContentPlaylist) {
			// MTVW-998
			//console.debug("_checkEventAsync", endTs(this.GetEvent) - eventTime)
			if (endTs(this.GetEvent) && endTs(this.GetEvent) - eventTime <= 0) {
				if (!this.recordingEndReached) {
					yield rootStore.page.CoCoBookmarks.playbackProgress(this.player, endTs(this.GetEvent))
					this.recordingEndReached = true
					//console.debug("_checkEventAsync end")
				}
			}
			// MTVW-838: exclude SourceTypeList.ContentPlaylist)
			return
		}
		// MTVW-717: Added condition, if the player 'isLoading', the eventTime could be garbage
		if (this.playEventActive && this.player.isStreamLoaded && !this.player.isLoading && this.channelId && eventTime !== null && !isTimeInEventRange(eventTime, this.Event)) {
			// MTVW-998
			//console.debug("_checkEventAsync playbackProgress", this.type, this.GetEvent.content.Title, this)
			// MTVW-1101: use eventTime instead of endTs(this.GetEvent) to avoid potential issues with wrong event end time
			//if (endTs(this.GetEvent)) yield rootStore.page.CoCoBookmarks.playbackProgress(this.player, endTs(this.GetEvent))
			if (eventTime) yield rootStore.page.CoCoBookmarks.playbackProgress(this.player, eventTime)
			// MTVW-487: replace traxis rootStore.api.GetEventByChannelTime with epgMS implementation
			this.GetEvent = yield this.msEpg?.getEventByChannelTime(this.channelId, eventTime)
			//console.debug("_checkEventAsync %o, %o, %o", eventTime, this.GetEvent, this.Event)

			//console.debug("_checkEventAsync %o, %s", this.Event, this.Event.id)
			// GT12: prevent displaying adSkipInfo when switching from end of Live TV show to next one
			if (this.Event) {
				yield rootStore.page.OverlayEventDetails.setEpgEventById(eventId(this.Event), false, {})
				//this.sessionAdZones = yield this.getAdZones(startTs(this.Event), endTs(this.Event), this.player?.positionTimeStamp)
				//this.sessionEnd = endTs(this.Event)
				//console.debug("this.type %s, restart %s", this.type, this.restartDone)
				// MTVW-486: switching to live show from previous show
				//if ((endTs(this.Event) < moment().utc().valueOf()) && this.type === SourceTypeList.ChannelReplay) {
				if (/*(eventTime < moment().utc().valueOf()) &&*/ this.type === SourceTypeList.ChannelReplay) {
					cDebug("SWITCHING to trueReplaySession", eventTime, moment(eventTime).utc().format(TIME_FORMAT_BACKEND), channelId(this.Event?.event), startTs(this.Event), this.Event, this)
					// (MTVW-678) below could be an alternative solution to reload the stream for each show start
					// check eventTime vs. startTs(this.Event)
					//this.trueReplaySession = true
					//yield this.__parent.setPlayChannelReplayAsync(this.Event.event.channelId, eventTime, this.Event)
					this.trueReplaySession = true
					yield this._startReplaySession(startTs(this.Event), endTs(this.Event), null, false)
				}
				// MTVW-486
				//else {
				else if (this.type === SourceTypeList.ChannelLive) {
					// live
					if (!this.restartDone) {
						this.trueReplaySession = false
					}
					else {
						yield this._startReplaySession(startTs(this.Event), endTs(this.Event), null, false)
					}
				}
				//console.debug("CHANGE DETECTED %o %o %o", this.Event, this.player.__parent.source, this)
				//this.dumpAdZones()
			}
		}
		return false
	})

	_fetchEventAsync = flow(function* (time = null) {
		// MTVW-487: replace traxis rootStore.api.GetEventByChannelTime with epgMS implementation
		if (this.GetEvent === null) {
			if (!time) time = moment().utc().valueOf()
			this.GetEvent = yield this.msEpg?.getEventByChannelTime(this.channelId, time)
		}
	})

	handleSetPosition = flow(function* (positionMoment) {
		this.removePauseAd()
		this.player.setPositionTimeStamp(positionMoment)
		yield Promise.resolve()
	})

	setAsLoaded() {
		this.isLoading = false
		return this
	}

	handleStreamOnStart() {
		console.log("@()")
	}

	handleStreamOnEnd(positionTimeStamp) {
		console.log("@()")
	}

	// GT12
	continueAt = flow(function* (position = null) {
		/*
		this._parent._parent.setPlayChannelReplayAsync(this.id, Number(this.fastForwardAdInfo.jumpTo), this.Event).then(() => {
			this.player.setPositionTimeStamp(Number(this.fastForwardAdInfo.jumpTo))
			//this.setPause()
		})
		*/
		this.playlistLoadedCallback = () => {
			this.playlist.StreamInfo.eventStart = moment(position).utc().format(TIME_FORMAT_BACKEND)
		}
		yield this.openStreamAsync()
	})

	// GT12
	// NOTE: sometimes there are 2 events during fast forward ad
	// TODO: recheck, now called from VO_OSMP_CB_PLAY_STARTED (before from VO_OSMP_CB_PLAY_PLAYING)
	playStartEvent() {
		/*
		if (this.player.__path === "playerAds" && this.adPlayStart === 0) {
			document.getElementById("tvPlayer").style.display = "none"
			document.getElementById("adsPlayer").style.display = "block"
		}
		*/
		this.player.setIsPosterVisible(false, "playStartEvent", false, 300)

		// MTVW-754: Safari, make sure that adjustLiveTvSize is updated when returning to live tab
		controlsTimerHandler(rootStore.page.Player)
		setTimeout(() => {
			console.debug("playStartEvent adjustPlayerStyles")
			rootStore.page.Player.adjustPlayerStyles()
		}, 500)

		if (this.playEventActive) {
			// prevent multiple calls
			return
		}
		console.debug("playStartEvent=", this.player, this.__parent, this)
		/**/
		// MTVW-444
		if (this.__parent.playerFg) {
			this.playEventActive = false
			return
		}
		/**/
		this.playEventActive = true
		this.adPlayStart = moment().valueOf()
		this.__parent.adPlayStart = this.adPlayStart
		cDebug("SOURCE PLAY EVENT %o, %o, %o, %s", this, this.player._refElemContainer, this.player, moment(this.adPlayStart).format(TIME_FORMAT_BACKEND))
		// remove pause ad
		this.removePauseAd()
	}

	// MTVW-481
	//playCompleteEvent(positionTimeStamp) {
	playCompleteEvent = flow(function* (playbackStamp, metaDuration = 0, playTime = 0) {
		const parent = this.__parent
		console.debug("playCompleteEvent this %o, after %o, replayInfo %o", this, parent.playAfterAd, parent.replayAdInfo)
		if (parent.replayAdInfo) {
			console.debug("playCompleteEvent calling playAfterAd")
			//console.debug("STOP %o", this)
			yield parent.playAfterAd("", playbackStamp, metaDuration, playTime)
			parent.playEventActive = false
			parent.setReplayAdInfo(null)
		}
		if (this.player.__path !== "playerAds") {
			yield this.handleStreamOnEnd(playbackStamp)
		}
	})

	// GT12
	pauseEvent() {
		cDebug("SOURCE PAUSE EVENT %o, %o", this, this.adState)
		if (!(this.adState.fastFwd || this.adState.replay || this.disablePauseAd)) this.setPauseAd()
		this.disablePauseAd = false
	}

	// GT12
	//preloadEvent() {
	preloadEvent = flow(function* (ignore = false) {
		cDebug("PRELOAD EVENT %o, %o, %o", this, this.Event, this.player.__path, this.player.isPausedUser)
		// PRELOAD: in case we couldn't start playing already
		// MTVW-493: preloadEvent can be generated for content stream while ads player is playing
		//this.player.setIsPosterVisible(false, "preloadEvent")
		/**/
		// MTVW-444, MTVW-788, MTVW-787
		if (this.__parent.playerFg) {
			//this.player.setIsPosterVisible(false, "preloadEvent")
			if (import.meta.env.VITE_DISPOSE_LIVE_PLAYER === "true") {
				//console.debug("preload swap")
				yield this.__parent.swapPlayers()
				// now playerFg has been cleared
				if (!this.player.isPausedUser) this.player.setPause()
			}
			this._waitPreload.setResolve()
			return
		}
		/**/
		if (import.meta.env.VITE_PLAYER === "vjs") {
			// MTVW-444
			if (this.player.__path !== "playerAds" && this.player.isPausedUser && !ignore) yield this.player.setPlay("preloadEvent")
		}
		else if (import.meta.env.VITE_PLAYER === "vo") {
			if (this.player.__path !== "playerAds" && this.player.isPaused) yield this.player.setPlay("preloadEvent")
		}
	})

	//replayAdError(e, errorInfo = "other") {
	replayAdError = flow(function* (e, errorInfo = "other") {
		try {
			yield this.exitAdsPlayer()
			console.error("handleReplayAd error %o, %o", e, errorInfo, this.playAfterAd)
			yield this.playAfterAd(errorInfo, 0)
			this.setReplayAdInfo(null)
			this.playAfterAd = () => { }
			rootStore.logService.logAsync(logLevel.Error, "handleReplayAd", "SourceAbstract", e)
		}
		catch (e) {
			console.error("replayAdError exception", e)
		}
	})

	//ffAdError(e) {
	ffAdError = flow(function* (e) {
		try {
			yield this.exitAdsPlayer()
			this.player.setPositionTimeStamp(this.adEndPosition)
			this.setFfwdAdInfo(null)
			if (this.player.isPaused) yield this.player.setPlay("ffAdError")
			console.error("handleFastForwardAd error %o", e)
			this.playAfterAd = () => { }
			yield rootStore.logService.logAsync(logLevel.Error, "handleFastForwardAd", "SourceAbstract", e)
			// TODO: reporting ?
		}
		catch (err) {
			console.error("ffAdError exception", err)
		}
	})

	// generated after PlayerVo.openStreamAsync has completed
	errorEvent = flow(function* (error) {
		cDebug("type", this.type, this, this.__parent)
		const instance = this.type === SourceTypeList.AdPlaylist ? this.__parent : this
		//const instance = this
		cDebug("errorEvent", error, instance.adState.fastFwd, instance.adState.replay, instance)
		if (instance.adState.fastFwd) {
			instance.ffAdError(error)
		}
		else if (instance.adState.replay) {
			instance.replayAdError(error)
		}
		else {
			cDebug("no adState")
			rootStore.page.Player.error = error
			//this.exitAdsPlayer()
			// stop player
			//yield this.player?.setRefElemContainer(null)
			yield this.player?.stopInstance()
			if (import.meta.env.VITE_PLAYER === "vjs") {
				//yield this.__parent?.playerAds?.setRefElemContainer(null)
				yield this.__parent?.playerAds?.stopInstance()
			}
		}
	})

	// GT12
	interactionEvent = flow(function* (interaction, player, positionTimeStamp = null) {
		//interactionEvent(interaction, positionTimeStamp = null) {
		// pause ad: resume, close, changeAsset, interruption (background)
		// replay ad: changeAsset, interruption (background)
		// ff ad: changeAsset, interruption (background), skipPromo
		// GT12 TODO: how to track "skipPromo" in linear ad?
		cDebug("interactionEvent %s, %s, %s,  %o, %o", interaction, this.interactionActive, this, this.type, player?.__path, this._parent, this.__parent, positionTimeStamp)
		// Avoid potential recursion if PlayerVo._killPlayer is called
		//if (this.interactionActive) return
		this.interactionActive = true
		if (this.type === SourceTypeList.AdPlaylist) {
			// MTVW-588: setPlayCompleted
			this.player.setPlayCompleted()
			return
		}

		// MTVW-816
		// MTVW-951: added mutex
		const release = yield this._mutex.acquire()
		try {
			if (!player._source?.isOnDiscover) yield rootStore.page.CoCoBookmarks.notifyStopped(player, positionTimeStamp)

			if (this.__parent.isAdsPlayer) {
				const playbackTime = this.player.playbackTime ? Math.round(this.player.playbackTime * 1000) : this.adPlayStart ? moment().valueOf() - this.adPlayStart : 0
				// adPlayStart might be null if an error occured (no playEvent)
				const elapsedDuration = this.adPlayStart ? moment().valueOf() - this.adPlayStart : 0
				//console.debug("!!!interactionEvent %s, %s, %o", interaction, channelId, this)
				yield this.exitAdsPlayer()
				//console.debug("interaction ads replay %o, ff %o", this.replayAdInfo, this.fastForwardAdInfo)
				if (this.replayAdInfo) {
					cDebug("track replay ad: playbackTime %s, elapsed duration %s", playbackTime, elapsedDuration)
					try {
						if (this.sessionId) yield this.adsService.sessionTrackingReplayAdAsync(this.sessionId, this.replayAdInfo.replayAd.adsViewId, playbackTime, interaction, "")
					}
					catch (e) {
						console.error("interactionEvent track replay error %o", e)
						try {
							rootStore.logService.logAsync(logLevel.Error, "interactionEventRreplayAd", "SourceAbstract", e)
						}
						catch (e) {
							console.error("CAUGHT interactionEvent", e)
						}
					}
					finally {
						this.setReplayAdInfo(null)
						this.interactionActive = false
					}
				}
				else if (this.fastForwardAdInfo) {
					cDebug("track ff ad: playbackTime %s, elapsed duration %s", playbackTime, elapsedDuration)
					try {
						if (this.sessionId) yield this.adsService.sessionTrackingFastForwardAdAsync(this.sessionId, this.fastForwardAdInfo.fastForwardAd.adsViewId, playbackTime, interaction, "")
					}
					catch (e) {
						console.error("interactionEvent track ffw ad error %o", e)
						try {
							rootStore.logService.logAsync(logLevel.Error, "interactionEventFfwAd", "SourceAbstract", e)
						}
						catch (e) {
							console.error("CAUGHT interactionEvent", e)
						}
					}
					finally {
						this.setFfwdAdInfo(null)
						this.interactionActive = false
					}
				}
			}
			else if (this.pauseAd) {
				//console.debug("!!!interactionEvent %s, %s, %o", interaction, channelId, this)
				cDebug("track pause ad")
				try {
					if (this.sessionId) yield this.adsService.sessionTrackingPauseAdAsync(this.sessionId, this.pauseAd.adsViewId, Math.round(performance.now() - this.adPauseStart), interaction, "")
				}
				catch (e) {
					console.error("interactionEvent track pause ad error %o", e)
					try {
						rootStore.logService.logAsync(logLevel.Error, "interactionEventPauseAd", "SourceAbstract", e)
					}
					catch (e) {
						console.error("CAUGHT interactionEvent", e)
					}
				}
				finally {
					this.pauseAd = null
					this.interactionActive = false
				}
			}
			else this.interactionActive = false
		}
		catch (e) {
			console.error("interactionEvent", e)
		}
		finally {
			// release Mutex
			if (release) release()
		}
		//rootStore.page.Player.updatingStyles = false
	})

	// GT12
	handleReplayAd = flow(function* (adResponse, beforeAd, playAfterAd) {
		this.contentPlayerName = this._parent.player.__path
		//console.debug("serviceUrls %o", serviceUrls, this.contentPlayerName)
		let result = null
		this.playAfterAd = () => { }
		this.markerPosD = null
		this.adPlayStart = null
		// MTVW-725 session timeout, case of active ads
		const player = this.__parent.isAdsPlayer ? this._player : this.player
		if (this.isBvChannel(channelId(this.Event))) {
			//result = yield this.adsService.startReplayAsync(channelId, epgEventStart, epgEventEnd, bookmarkPosition)
			cDebug(">>>handleReplayAd %o, %o, %o", adResponse, this.trueReplaySession, this.restartDone)
			if (adResponse?.replayAd?.adUrl) {
				//adResponse.replayAd.adUrl = "http://89.236.171.48/processed/a1155e20-1d41-45f2-8a20-e24ecbf8874f/master.m3u8"
				//adResponse.replayAd.adUrl = "https://services.qltv.stage.quickline.ch/ads/v001/sessions/" + this.sessionId + "/playlists/fe73318c-e196-4076-a5c9-35c40aa8b7dc/master.m3u8"
				//this.setPlayPause()
				//adSource.replayAdInfo = adResponse
				this.setReplayAdInfo(adResponse)
				//adSource.playAfterAd = playAfterAd
				this.playAfterAd = playAfterAd
				beforeAd(Number(adResponse.contentStartPosition))
				// try to fetch the playlist in order we can handle potential errors
				let errorInfo = "adNotFound"
				try {
					//yield fetch(adResponse.replayAd.adUrl)
					yield this.enterAdsPlayer()
					const adSource = SourceAdPlaylist.create(this, adResponse.replayAd.adUrl)
					// source is used for progress bar
					//this._parent.source = adSource
					result = adResponse
					errorInfo = "other"
					// MTVW-725: use this.player !
					if (!this.restartDone) yield this.player.setSource(adSource).openStreamAsync()
					// GT12 TODO: don't report
					else yield playAfterAd(errorInfo, 0)
					// test purpose
					//rootStore.logService.logAsync(logLevel.Info, "handleReplayAd", "SourceAbstract", result /*{ a: 1, b: 2, c: 3 }*/)
				}
				catch (e) {
					/*
					// MTVW-512: Playlist not found error handling
					this.exitAdsPlayer()
					console.error("handleReplayAd error %o, %o", e, errorInfo)
					playAfterAd(errorInfo, 0)
					this.setReplayAdInfo(null)
					this.playAfterAd = () => { }
					rootStore.logService.logAsync(logLevel.Error, "handleReplayAd", "SourceAbstract", e)
					*/
					this.replayAdError(e, errorInfo)
					return null
				}
				//console.debug("PLAYER NOW %o, %o", this.player, this._parent)
			}
			else {
				// returned result is null
			}
		}
		//if (!result) this._parent.handlePlaySourcePreserveProgressBarAsync(source)
		//if (!result) playAfterAd()
		this.restartDone = true
		return result
	})

	// GT12
	handleFastForwardAd = flow(function* (from, to, playAfterAd) {
		this.contentPlayerName = this._parent.player.__path
		//console.debug("handleFastForwardAd", this.isBvChannel(channelId(this.Event)), this.sessionId, this.trueReplaySession, playAfterAd)
		this.playAfterAd = () => { }
		this.adEndPosition = to
		this.adPlayStart = null
		if (this.isBvChannel(channelId(this.Event)) && this.sessionId && this.trueReplaySession) {
			const AvailabilityStartTs = startTs(this.Event)
			const AvailabilityEndTs = endTs(this.Event)

			//const from = this.player?.positionTimeStamp
			// sessionId, epgEventStart, epgEventEnd, from, to
			// TODO: sometimes after ffwad and then starting replay AvailabilityStartTs and AvailabilityEndTs are missing
			try {
				// MTVW-521: reset markerPosD
				this.markerPosD = null
				const inAdZone = this.checkAdZones(from) /*|| this.checkAdZones(to)*/ ? true : false
				const adResponse = this.sessionId ? yield this.adsService.sessionVerifyJumpAsync(this.sessionId, channelId(this.Event), AvailabilityStartTs, AvailabilityEndTs, from, to, inAdZone) : null
				//console.debug("sessionVerifyJumpAsync %o, from %s, inAdZone %s", adResponse, from, inAdZone)
				cDebug("adResponse %o. adState %o", adResponse, this.adState)
				if (adResponse?.fastForwardAd?.adUrl) {
					// TEST with specific playlist
					//adResponse.fastForwardAd.adUrl = "https://services.qltv.stage.quickline.ch/ads/v001/sessions/823017f9-b7b7-4a89-b297-4c80017836d3/playlists/fe73318c-e196-4076-a5c9-35c40aa8b7dc/master.m3u8"
					//adResponse.fastForwardAd.adUrl = "https://services.qltv.stage.quickline.ch/ads/v001/sessions/" + this.sessionId + "/playlists/fe73318c-e196-4076-a5c9-35c40aa8b7dc/master.m3u8"
					// internal pause, don't request pause ad
					this.disablePauseAd = true
					// MTVW-506: pre-position to D marker (for improved smoothness) and pause content stream
					this.player.setPositionTimeStamp(Number(adResponse.jumpTo))
					if (!this.player.isPaused) this.setPlayPause()
					this.adStartPosition = this.player?.positionTimeStamp
					yield this.enterAdsPlayer()
					const adSource = SourceAdPlaylist.create(this, adResponse.fastForwardAd.adUrl)
					//adSource.fastForwardAdInfo = adResponse
					this.setFfwdAdInfo(adResponse)
					//adSource.playAfterAd = playAfterAd
					this.playAfterAd = playAfterAd
					// source is used for progress bar
					//this._parent.source = adSource
					yield this.player.setSource(adSource).openStreamAsync()
				}
				else {
					//console.debug("NO AD")
					if (adResponse?.action === "allow") {
						console.warn("JUMP allowed")
						yield this.player.setPositionTimeStampAsync(Number(adResponse.jumpTo))
						if (Number(adResponse.jumpTo) === Number(this.adZone?.end)) {
							console.warn("JUMP D Marker")
							this.markerPosD = Number(this.adZone?.end)
						}
						// MTVW-534: Disable. Kurwerbung button would appear insted of skip when forwarding in adZone
						//this.markerPosD = Number(adResponse.jumpTo)
						// MTVW-649: disable notifyJump
						//yield this.adsService.sessionNotifyJumpAsync(this.sessionId, AvailabilityStartTs, AvailabilityEndTs, from, Number(adResponse.jumpTo)	)
					}
					else if (adResponse?.action === "deny") {
						yield this.player.setPositionTimeStampAsync(to)
						console.error("JUMP DENIED")
						rootStore.logService.logAsync(logLevel.Error, "handleFastForwardAd", "SourceAbstract", adResponse)
					}
				}
			}
			catch (e) {
				/*
				// MTVW-512: Playlist not found error handling
				this.exitAdsPlayer()
				this.player.setPositionTimeStamp(to)
				if (this.player.isPaused) yield this.player.setPlay("catch handleFastForwardAd")
				console.error("handleFastForwardAd error %o", e)
				this.playAfterAd = () => { }
				rootStore.logService.logAsync(logLevel.Error, "handleFastForwardAd", "SourceAbstract", e)
				// TODO: reporting ?
				*/
				yield this.ffAdError(e)
			}
		}
		else {
			//console.debug("DEFAULT CASE", from, to)
			yield this.player.setPositionTimeStampAsync(to)
		}
		//console.debug("this.playAfterAd", this.playAfterAd)
		return
	})

	// GT12
	getAdZones = flow(function* (start, end, playbackPosition) {
		if (this.isBvChannel(channelId(this.Event)) && this.sessionId) {
			try {
				if (!playbackPosition || playbackPosition < start) playbackPosition = start
				const result = this.sessionId ? yield this.adsService.sessionAdZonesAsync(this.sessionId, start, end, playbackPosition) : null
				cDebug("aZ: %o, s: %s, e: %s, nP %s", result, moment(start).utc().format(TIME_FORMAT_BACKEND), moment(end).utc().format(TIME_FORMAT_BACKEND), moment(Number(result?.nextPositionToCheck)).utc().format(TIME_FORMAT_BACKEND))
				if (result) this.dumpAdZones(result)
				this.adZoneFetchPosiiton = playbackPosition
				return result
			}
			catch (e) {
				console.error("getAdZones error %o", e)
				rootStore.logService.logAsync(logLevel.Error, "getAdZones", "SourceAbstract", e)
			}
		}
		return null
	})

	dumpAdZones(zones = null) {
		if (!zones) zones = this.sessionAdZones
		if (zones) {
			zones.adZones.forEach(i => {
				cDebug("s: %s, sk: %s, e: %s", moment(Number(i.start)).utc().format(TIME_FORMAT_BACKEND), moment(Number(i.skipStart)).utc().format(TIME_FORMAT_BACKEND), moment(Number(i.end)).utc().format(TIME_FORMAT_BACKEND))
			})
		}
	}

	// GT12
	timeStampEvent(timeStamp, offsetSeconds, playCompleted) {
	}

	// GT12
	checkForLinearAd(timeStamp, offsetSeconds) {
		// TEST purpose
		//const lastSkipState = linear.skip
		//const adjustedStamp = Math.round((timeStamp) / 1000) * 1000
		const adjustedStamp = timeStamp
		// MTVW-535: avoid button display artifacts when jumping to D marker
		if (this.markerPosD) {
			const SAMPLE_RATE = 1000
			if (adjustedStamp < this.markerPosD - 2 * SAMPLE_RATE) {
				this.adState.linear = null
				this.setFfwdAdInfo(null)
				cDebug("cond a")
			}
			else if (adjustedStamp <= this.markerPosD + SAMPLE_RATE) {
				this.adState.linear = null
				this.setFfwdAdInfo(null)
				cDebug("cond b")
				return
			}
			else if (adjustedStamp > this.markerPosD + SAMPLE_RATE) {
				this.adState.linear = null
				this.setFfwdAdInfo(null)
				this.markerPosD = null
				cDebug("cond c")
			}
		}
		this.checkAdZones(timeStamp, offsetSeconds)
		//console.debug("checkForLinearAd %o, %s, %o", this.adZone, this.debounceEvent, this.sessionAdZones)
		if (!this.adState.fastFwd) {
			//this.checkAdZones(timeStamp, offsetSeconds)

			//const promoDuration = 7000
			const adZone = this.adZone
			if (adZone) {
				let skip = false
				if (adjustedStamp >= Number(adZone.skipStart) && adjustedStamp < Number(adZone.end) /*- 2000*/) {
					//promoCountdown = 0
					// MTVW-544: suppress "Überspringen" after ffad
					if (!this.markerPosD) skip = true
				}
				//let promoCountdown = 0
				// MTVW-534: Avoid visual intermittent Kurzwerbung button when complete adZone can be skipped. Provide skip in constructor.
				if (!this.adState.linear) this.adState.linear = new LinearAd(skip)
				const linear = this.adState.linear

				if (adjustedStamp >= Number(adZone.end)) {
					this.adState.linear = null
				}
				linear.setValues(skip /*, promoCountdown*/)
				//console.debug("AD ZONE %s, %o", timeStamp, moment(timeStamp).utc().format(TIME_FORMAT_BACKEND), adZone)
				// TEST purpose
				/*
				if (!lastSkipState && skip) {
					console.debug("SKIP NOW")
					this.skipAd()
				}
				*/
			}
			else this.adState.linear = null
		}
		//if (this.markerPosD) console.debug("markerPosD ff %o, %s", this.adState.fastFwd, this.markerPosD)
	}

	// GT12
	// for replay and content streams: replay ad and fast forward ad
	//adStampEvent(timeStamp, playTime, playCompleted) {
	adStampEvent = flow(function* (timeStamp, playTime, playCompleted) {
		// MTVW-588: Safari is quite accurate
		const SAMPLING_RATE = isSafari() ? 0 : 100
		//console.debug("AD STAMP %s, %s, PLAY TIME %s, %o, %o, %o", timeStamp, moment(timeStamp).utc().format(TIME_FORMAT_BACKEND), playTime, this.adZone, this.replayAdInfo, this)
		if (this.replayAdInfo) {
			playTime *= 1000
			if (!this.adState.replay) this.adState.replay = new ReplayAd()
			const replayAd = this.replayAdInfo.replayAd
			//console.debug("adStampEvent %o, %s", replayAd, playTime)
			if (playTime >= Number(replayAd?.countdownDelay)) {
				// MTVW-588: shift by 1 second, cap minium to 1 second
				let countDown = 1000 + Number(replayAd.countdownDuration) + Number(replayAd.countdownDelay) - playTime
				countDown = countDown >= 1000 ? countDown : 0
				//console.debug("REPLAY AD %s, %s", countDown, moment().valueOf())
				this.adState.replay.setCountdown(countDown)
			}
			//console.debug("adStampEvent %o, %o", this, this.playAfterAd)
			// MTVW-481: Handled in playCompleteEvent
			/*
			if (playTime >= Number(replayAd?.countdownDelay) + Number(replayAd?.countdownDuration)) {
				//console.debug("STOP %o", this)
				this.playAfterAd()
				this.playEventActive = false
				this.setReplayAdInfo(null)
			}
			*/
		}
		else if (this.fastForwardAdInfo) {
			// MTVW-588: workaround to mitigate issue with times from jumpVerify / replay ad and effective play time
			//playTime *= 990
			playTime = playTime * 1000// + SAMPLING_RATE

			//console.debug("STAMP FFW %s, %o", playTime, this.fastForwardAdInfo)
			//if (!this.adState.fastFwd) this.adState.fastFwd = new FastFwdAd()
			//if (this.markerPosD) return
			const ffwdAd = this.fastForwardAdInfo.fastForwardAd
			//console.debug("ffwdAd %o, tStamp %s, playTime %s, nowStamp %s, jumpTo %s", ffwdAd, this.adStartPosition, playTime, this.adStartPosition + playTime, Number(this.fastForwardAdInfo.jumpTo))
			let skip = false
			//const lastSkipState = this.adState.fastFwd.skip
			if (ffwdAd.adsStart) {
				let adCount = ffwdAd.adsStart?.length
				let adNumber = 0
				let promoCountdown = 0
				for (let i = 0; i < adCount; i++) {
					if (playTime - 4 * SAMPLING_RATE >= Number(ffwdAd.adsStart[i])) adNumber = i + 1
				}
				// MTVW-496, MTVW-539: Consider adsEnds information
				if (ffwdAd.adsEnds && playTime - 4 * SAMPLING_RATE >= Number(ffwdAd.adsEnds[adCount - 1])) {
					adNumber = 0
				}
				// MTVW-588: adjust by 1100 to avoid rounding / sampling issues
				const ADJUST = 1100
				if (ffwdAd.promoStart && playTime >= Number(ffwdAd.promoStart) + ADJUST) {
					adCount = 0
					adNumber = 0
					promoCountdown = Math.round((Number(ffwdAd.promoStart) + ADJUST + Number(ffwdAd.promoCountdown) - playTime) / 1000) * 1000
					if (playTime >= Number(ffwdAd.promoStart) + ADJUST + Number(ffwdAd.promoCountdown) /*&& !this.markerPosD*/) {
						//console.debug("SKIP playTime %s, promStart %s, countdown %s, promoCountdown %s", playTime, Number(ffwdAd.promoStart), promoCountdown, Number(ffwdAd.promoCountdown))
						promoCountdown = 0
						skip = true
					}
					//else console.debug("playTime %s, promStart %s, countdown %s, promoCountdown %s", playTime, Number(ffwdAd.promoStart), promoCountdown, Number(ffwdAd.promoCountdown))
				}
				if (!this.adState.fastFwd) this.adState.fastFwd = new FastFwdAd(skip, promoCountdown, adNumber, adCount)
				else this.adState.fastFwd.setValues(skip, promoCountdown, adNumber, adCount)
			}
			// GT12 TODO: this.adStartPosition not needed

			if (playCompleted && this.fastForwardAdInfo /*|| this.adStartPosition + playTime >= Number(this.fastForwardAdInfo.jumpTo)*/) {
				console.debug("adStampEvent calling playAfterAd")
				yield this.playAfterAd("", timeStamp, playTime, playCompleted)
				this.playEventActive = false
				this.setFfwdAdInfo(null)
			}
			// TEST purpose
			//if (!lastSkipState && skip) this.skipAd()
		}
	})

	// GT12
	checkAdZones(timeStamp) {
		if (this.sessionAdZones) {
			if (this.markerPosD) {
				this.adZone = null
				return null
			}
			//console.debug("checkAdZones", this.Event)
			//this.dumpAdZones()

			// check for update of adZones
			let fetchAdZones = false
			if (timeStamp && this.adZoneFetchPosiiton && timeStamp < this.adZoneFetchPosiiton) {
				cDebug("update adZones: ts %s < fp %s", timeStamp, this.adZoneFetchPosiiton)
				fetchAdZones = true
			}
			if (timeStamp && timeStamp >= Number(this.sessionAdZones.nextPositionToCheck)) {
				cDebug("update adZones: %s >= %s, end %s", timeStamp, Number(this.sessionAdZones.nextPositionToCheck), this.sessionEnd)
				fetchAdZones = true
			}
			if (fetchAdZones && timeStamp && this.Event) {
				try {
					this.getAdZones(startTs(this.Event), endTs(this.Event), timeStamp).then((result) => {
						runInAction(() => { this.sessionAdZones = result; cDebug("NEW AD ZONES %o", this.sessionAdZones) })
					})
				}
				catch (e) {
					console.error("checkAdZones OOPS %o, %o", e, this.Event)
				}
			}

			let adZone = null
			this.sessionAdZones?.adZones?.forEach(i => {
				//console.debug("checkAdZones %s, %s, %s", moment(Number(i.start)).utc().format(TIME_FORMAT_BACKEND), moment(Number(i.end)).utc().format(TIME_FORMAT_BACKEND), moment(timeStamp).utc().format(TIME_FORMAT_BACKEND))
				if ((timeStamp >= Number(i.start)) && (timeStamp < Number(i.end))) {
					//console.debug("adZone=", i)
					adZone = i
				}
			})

			/*
			if (this.markerPosD && timeStamp >= this.markerPosD - 2000) {
				if (this.adState.linear) this.adState.linear = null //this.adState.linear.skip = false
				if (this.adState.fastFwd) this.setFfwdAdInfo(null)
				this.adZone = null
			} else this.adZone = adZone
			*/
			this.adZone = adZone
			//console.debug("timestamp %s, %s", timeStamp, moment(timeStamp).utc().format(TIME_FORMAT_BACKEND))
		}
		else this.adZone = null
		/*
		if (!this.adZone && this.markerPosD && !this.timeoutId) this.timeoutId = setTimeout(() => {
			//console.debug("setTimeout")
			//this.markerPosD = null
			// MTVW-521: we could be again in an adZone meanwhile
			if (!this.adZone && this.markerPosD) this.setFfwdAdInfo(null)
			this.timeoutId = null
		}, 5000)
		*/
		return this.adZone
	}

	// GT12
	// MTVW-1101: callBack for onNextEpisodeClick
	skipAd = flow(function* (callBack = null) {
		if (!this.debounced()) return
		yield rootStore.page.CoCoBookmarks.playbackProgress(this.player, this.player.positionTimeStamp)

		//console.debug("skipAd %o, %o", this.adState, this)
		if (this.adState.fastFwd !== null) {
			cDebug("skip to content after skipStart", this.adZone)
			this.adState.linear = null
			this.markerPosD = Number(this.adZone?.end)
			yield this.playAfterAd("skipPromo")
			this.playEventActive = false
			this.setFfwdAdInfo(null)
		}
		else if (this.adState.linear !== null) {
			if (!this.adState.linear.skip) {
				this.adState.linear = null
				this.setFfwdAdInfo(null)
				cDebug("skip to ff ad")
				// MTVW-486
				//this.setJumpFwd()
				// MTVW-1101
				/*
				if (callBack && this.nextEpisodeInfo?.start &&
					Number(this.adZone?.end) >= endTs(this.Event?.event)) {
						//this.setJumpMarker(this.MARKER_N)
						cDebug("skip to next episode")
						callBack()
				}
				else if (this.adZone) yield this.handleSetPosition(moment(Number(this.adZone.end)).utc())
				*/
				if (this.adZone) yield this.handleSetPosition(moment(Number(this.adZone.end)).utc())
				//this.markerPosD = moment(Number(this.adZone.end)).utc()
				//this.player.setPositionTimeStamp(Number(this.adZone.end))
			}
			else {
				cDebug("skip to D marker")
				if (this.adZone) {
					yield this.player.setPositionTimeStampAsync(Number(this.adZone.end))
					this.markerPosD = Number(this.adZone?.end)
				}
			}
		}
	})
}
